function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n     #bg-section-19 .cls-1 {\r\n        fill: #fff;\r\n        opacity: 0.5;\r\n        isolation: isolate;\r\n      }\r\n    "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "bg-section-19",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "oval-seccao-19"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_2259",
  "data-name": "Path 2259",
  className: "cls-1 rotate-center",
  d: "M175.1,179.38a63.39,63.39,0,0,1-9,4.74h0s-51.43,24.39-113.25,11.07h0A63.42,63.42,0,0,1,9.78,166.11a64.52,64.52,0,0,1-7.31-51.84C17.25,52.43,61.05,16.18,61.31,16a63.4,63.4,0,0,1,81.92-1.78s34,25.68,57.07,86.94h0A64.58,64.58,0,0,1,175.1,179.38Z"
})));

function SvgOvalSeccao19(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 204.88 199.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOvalSeccao19);
export default __webpack_public_path__ + "static/media/oval-seccao-19.bfe3227a.svg";
export { ForwardRef as ReactComponent };